/* SpinFlame ZA - Design v3 : shared UI behaviours (production code, adapted from the design runtime's intent only).
   Each behaviour is opt-in through a data attribute and works with server-rendered markup.
     [data-sv3-slider]    home accessories slider (prev / next / thumbs)
     [data-sv3-carousel]  scroll-snap carousel with prev / next buttons
     [data-sv3-accordion] accordion, one panel open at a time
     [data-sv3-tabs]      tabs (WAI-ARIA tab pattern with arrow keys)
     [data-sv3-gallery]   product gallery: thumbnails swap the main image
     [data-sv3-qty]       quantity stepper (minimum 1)
     [data-sv3-sort]      collection sort select (navigates with ?sort_by=)
   window.Sv3Cart.add(lines) posts to /cart/add.js and refreshes the theme cart drawer. */
(function () {
  'use strict';
  if (window.__sv3UiInit) return;
  window.__sv3UiInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  /* ------------------------------------------------------------------ cart */
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  window.Sv3Cart = {
    add: function (lines) {
      var cartEl = document.querySelector('cart-drawer');
      var payload = { items: lines };
      if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
        payload.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        payload.sections_url = window.location.pathname;
      }
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Cart request failed');
          if (cartEl && typeof cartEl.renderContents === 'function' && data.sections) {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sv3' });
            }
            if (cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
            cartEl.renderContents(data);
          } else {
            window.location.href = root + 'cart';
          }
          return data;
        });
      });
    }
  };

  /* ---------------------------------------------------------------- slider */
  function initSlider(el) {
    var slides = $$(el, '[data-slider-slide]');
    var shots = $$(el, '[data-slider-shot]');
    var thumbs = $$(el, '[data-slider-thumb]');
    var counter = el.querySelector('[data-slider-counter]');
    var n = slides.length;
    var current = 0;
    if (!n) return;
    function go(i) {
      current = (i + n) % n;
      slides.forEach(function (s, k) { s.hidden = k !== current; });
      shots.forEach(function (s, k) { s.hidden = k !== current; });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-current', k === current);
        if (k === current) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = pad2(current + 1) + ' / ' + pad2(n);
    }
    var prev = el.querySelector('[data-slider-prev]');
    var next = el.querySelector('[data-slider-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(current - 1); }
      else if (e.key === 'ArrowRight') { go(current + 1); }
    });
    go(0);
  }

  /* -------------------------------------------------------------- carousel */
  function initCarousel(el) {
    var track = el.querySelector('[data-carousel-track]');
    var prev = el.querySelector('[data-carousel-prev]');
    var next = el.querySelector('[data-carousel-next]');
    if (!track) return;
    function step() {
      var card = track.querySelector('[data-carousel-item]');
      if (!card) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function behavior() { return reduceMotion.matches ? 'auto' : 'smooth'; }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: behavior() }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: behavior() }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* ------------------------------------------------------------- accordion */
  function initAccordion(el) {
    var items = $$(el, '[data-acc-item]');
    function set(item, open) {
      var btn = item.querySelector('[data-acc-button]');
      var panel = item.querySelector('[data-acc-panel]');
      var icon = item.querySelector('[data-acc-icon]');
      item.classList.toggle('is-open', open);
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.hidden = !open;
      if (icon) icon.textContent = open ? '−' : '+';
    }
    items.forEach(function (item) {
      var btn = item.querySelector('[data-acc-button]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        if (el.hasAttribute('data-acc-single')) items.forEach(function (o) { if (o !== item) set(o, false); });
        set(item, open);
      });
    });
  }

  /* ------------------------------------------------------------------ tabs */
  function initTabs(el) {
    var tabs = $$(el, '[role="tab"]');
    var panels = $$(el, '[role="tabpanel"]');
    var imgs = $$(el, '[data-tab-image]');
    function select(i, focus) {
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        t.classList.toggle('is-selected', on);
      });
      panels.forEach(function (p, k) { p.hidden = k !== i; });
      imgs.forEach(function (p, k) { p.hidden = k !== i; });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        var n = tabs.length, k = null;
        if (e.key === 'ArrowRight') k = (i + 1) % n;
        else if (e.key === 'ArrowLeft') k = (i - 1 + n) % n;
        else if (e.key === 'Home') k = 0;
        else if (e.key === 'End') k = n - 1;
        if (k !== null) { e.preventDefault(); select(k, true); }
      });
    });
    var start = tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
    select(start < 0 ? 0 : start, false);
  }

  /* --------------------------------------------------------------- gallery */
  function initGallery(el) {
    var mediaItems = $$(el, '[data-gallery-media]');
    var thumbs = $$(el, '[data-gallery-thumb]');
    var mainImage = el.querySelector('[data-gallery-main]');
    if (!thumbs.length || (!mediaItems.length && !mainImage)) return;

    function pick(btn) {
      var id = btn.getAttribute('data-media-id');

      thumbs.forEach(function (thumb) {
        var current = thumb === btn;
        thumb.classList.toggle('is-current', current);
        if (current) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });

      if (mediaItems.length) {
        mediaItems.forEach(function (item) {
          var current = item.getAttribute('data-gallery-media') === id;
          item.hidden = !current;
          item.classList.toggle('is-hidden', !current);
          if (!current) {
            var video = item.querySelector('video');
            if (video) video.pause();
          }
        });
      } else {
        var src = btn.getAttribute('data-src');
        var srcset = btn.getAttribute('data-srcset');
        var alt = btn.getAttribute('data-alt');
        if (src) mainImage.src = src;
        if (srcset) mainImage.srcset = srcset;
        else mainImage.removeAttribute('srcset');
        if (alt !== null) mainImage.alt = alt;
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { pick(thumb); });
    });

    el.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      var index = thumbs.findIndex(function (thumb) { return thumb === document.activeElement; });
      if (index < 0) return;
      var next = event.key === 'ArrowRight'
        ? Math.min(thumbs.length - 1, index + 1)
        : Math.max(0, index - 1);
      thumbs[next].focus();
      pick(thumbs[next]);
    });
  }

  /* -------------------------------------------------------------- quantity */
  function initQty(el) {
    var input = el.querySelector('[data-qty-input]');
    var out = el.querySelector('[data-qty-value]');
    var dec = el.querySelector('[data-qty-dec]');
    var inc = el.querySelector('[data-qty-inc]');
    if (!input) return;
    var max = parseInt(el.getAttribute('data-qty-max') || '99', 10);
    function set(v) {
      v = Math.max(1, Math.min(max, v));
      input.value = v;
      if (out) out.textContent = v;
      if (dec) dec.disabled = v <= 1;
      if (inc) inc.disabled = v >= max;
      el.dispatchEvent(new CustomEvent('sv3:qty', { bubbles: true, detail: { value: v } }));
    }
    if (dec) dec.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) - 1); });
    if (inc) inc.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) + 1); });
    set(parseInt(input.value, 10) || 1);
  }

  /* ------------------------------------------------------------------ sort */
  function initSort(el) {
    el.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', el.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  function init(scope) {
    scope = scope || document;
    $$(scope, '[data-sv3-slider]').forEach(function (el) { if (!el.__sv3) { el.__sv3 = 1; initSlider(el); } });
    $$(scope, '[data-sv3-carousel]').forEach(function (el) { if (!el.__sv3) { el.__sv3 = 1; initCarousel(el); } });
    $$(scope, '[data-sv3-accordion]').forEach(function (el) { if (!el.__sv3) { el.__sv3 = 1; initAccordion(el); } });
    $$(scope, '[data-sv3-tabs]').forEach(function (el) { if (!el.__sv3) { el.__sv3 = 1; initTabs(el); } });
    $$(scope, '[data-sv3-gallery]').forEach(function (el) { if (!el.__sv3) { el.__sv3 = 1; initGallery(el); } });
    $$(scope, '[data-sv3-qty]').forEach(function (el) { if (!el.__sv3) { el.__sv3 = 1; initQty(el); } });
    $$(scope, '[data-sv3-sort]').forEach(function (el) { if (!el.__sv3) { el.__sv3 = 1; initSort(el); } });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
